import React from 'react'
import {VmoAccountUserImage} from 'vmo-library'
import {get, getFullNameFromObj} from 'utils/helper'
import {getUserInfo, getProfilePicColor} from 'utils/local-storage'
import DummyAvtarAccountUser from './DummyAvtar'

const AccountUserImage = () => {
  const userData = getUserInfo()
  return (
    <VmoAccountUserImage
      style={{
        backgroundColor: getProfilePicColor(),
      }}
      data-test="accountUserImage"
      src={get(['avatar'], userData)}
      name={getFullNameFromObj(userData)}
      type="square"
    />
  )
}

export default React.memo(AccountUserImage)
